import gql from "graphql-tag";
import React from "react";
import Card from "shared/components/cards/Card";
import { Spinner } from "shared/components/controls";
import { useMemoQuery } from "shared/hooks";
import { cardStyle, cardStyleError, moreInfoLinkStyle } from "shared/styles/styles";

export const FACILITY_INFO_QUERY = gql`
    query facilityInfo($shortName: String) {
        networkEntity(shortName: $shortName, entityType: "Facility") {
            id
            shortName
            fullName
            type
            description
            parent {
                shortName
                fullName
            }
        }
    }
`;

export const FacilityCard = ({ facilityId, showDescription = true, height = 75 }) => {
    const queryOptions = {
        // Change facility to lower case since it's stored in the database in this format
        variables: { shortName: facilityId.toLowerCase() },
    };

    // prettier-ignore
    const {
        isLoading,
        error,
        data: entity,
    } = useMemoQuery(FACILITY_INFO_QUERY, queryOptions, (d) => d.networkEntity, [facilityId]);

    if (isLoading) {
        return (
            <Card overLevel={2} outLevel={1} level={1} width="100%" style={cardStyle}>
                <Spinner />
            </Card>
        );
    } else if (error) {
        return (
            <Card
                overLevel={2}
                outLevel={1}
                level={1}
                width="100%"
                height={100}
                style={cardStyleError}
            >
                Unable to load facility information
            </Card>
        );
    } else {
        return (
            <Card overLevel={2} outLevel={1} level={1} width="100%" style={cardStyle}>
                <table width="100%">
                    <tbody>
                        <tr>
                            <td>
                                <b>{entity.type}</b>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <b>{entity.fullName}</b>
                            </td>
                        </tr>
                        {showDescription ? (
                            <tr>
                                <td style={{ marginTop: "80px" }}>{entity.description}</td>
                            </tr>
                        ) : (
                            <tr />
                        )}
                        <tr>
                            <td>
                                {" "}
                                <a
                                    style={moreInfoLinkStyle}
                                    href={`/facilities/view/${entity.shortName}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <span> MORE INFO » </span>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </Card>
        );
    }
};
